module.exports = __webpack_public_path__ + "img/img30.bf9ad91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img30.jpg
// module id = 328
// module chunks = 0